import { useState, useEffect } from 'react';

export const useModalState = () => {
  const [showBusinessOptionsModal, setShowBusinessOptionsModal] = useState(false);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  const [showProductTour, setShowProductTour] = useState(false);
  const [showLanguageSelector, setShowLanguageSelector] = useState(false);

  
  // Close modals when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showBusinessOptionsModal && !event.target.closest('.modal-content')) {
        setShowBusinessOptionsModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showBusinessOptionsModal]);
  
  // Handle welcome popup
  const handleCloseWelcomePopup = () => {
    setShowWelcomePopup(false);
    localStorage.setItem('oaklandAI-welcome-seen', 'true');
  };

  const resetWelcomePopup = () => {
    setShowWelcomePopup(true);
    localStorage.removeItem('oaklandAI-welcome-seen');
  };

  // Handle product tour
  const handleStartProductTour = () => {
    setShowProductTour(true);
  };

  const handleCompleteProductTour = () => {
    setShowProductTour(false);
    localStorage.setItem('oaklandAI-tour-completed', 'true');
  };
  
  // Handle business options modal
  const handleCloseBusinessOptionsModal = (show = false) => {
    setShowBusinessOptionsModal(show);
  };
  
  return {
    // Modal states
    showBusinessOptionsModal,
    setShowBusinessOptionsModal,
    showWelcomePopup,
    showProductTour,
    showLanguageSelector,
    setShowLanguageSelector,
    
    // Modal handlers
    handleCloseWelcomePopup,
    resetWelcomePopup,
    handleStartProductTour,
    handleCompleteProductTour,
    handleCloseBusinessOptionsModal
  };
};
